import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTypedDispatch } from "store";
import * as signInSelectors from "store/selectors/signIn";
import { isAdmin } from "config/constants";
import {
  canAccessMarketAreas,
  isMarketAreaAccessPending,
} from "store/selectors/marketAreas";
import { fetchMarketAreasAvailability } from "features/MarketAreas/MarketAreasActions";

export const useMarketAreaAvailability = () => {
  const canAccess = useSelector(canAccessMarketAreas);
  const isPending = useSelector(isMarketAreaAccessPending);
  return { canAccess, isPending };
};

export const useMarketAreaAvailabilityLoader = () => {
  const dispatch = useTypedDispatch();
  const { roles } = useSelector(signInSelectors.userInfo);
  const isAdminUser = isAdmin(roles);

  useEffect(() => {
    if (isAdminUser) return;
    dispatch(fetchMarketAreasAvailability());
  }, [dispatch, isAdminUser]);
};
